import { createFileRoute, Link, notFound } from "@tanstack/react-router";

import { HubPlacePage, hubPlaceQuery } from "@/components/hubs/HubPlacePage";
import { hubPlaceHead } from "@/lib/hub-seo";

export const Route = createFileRoute("/restaurants/$slug")({
  loader: async ({ params, context }) => {
    const data = await context.queryClient.ensureQueryData(hubPlaceQuery("restaurants", params.slug));
    if (!data) throw notFound();
    return data;
  },
  head: ({ params, loaderData }) =>
    hubPlaceHead({ path: `/restaurants/${params.slug}`, locale: "en", loaderData }),
  component: RestaurantsPlaceRoute,
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center p-8 text-center">
      <div>
        <h1 className="font-heading text-2xl">Restaurant not available</h1>
        <Link to="/restaurants" className="mt-6 inline-block text-royal underline">
          Browse all restaurants
        </Link>
      </div>
    </div>
  ),
});

function RestaurantsPlaceRoute() {
  const { slug } = Route.useParams();
  return <HubPlacePage hubSlug="restaurants" placeSlug={slug} locale="en" />;
}
